﻿import keycode from 'keycode'
import getTransitionDuration from 'get-transition-duration'

export class Collapsible {
  /**
   * @param {HTMLElement} element
   */
  constructor (element) {
    this.element = element
    this._expanded = element.dataset.expanded ? true : false
    this.element.Collapsible = this
    this.group = this.element.getAttribute('data-group') // the group name, if there's any present
    this.header = this.element.querySelector('[class$="header"]') // the accordion title (what you click to expand)
    this.body = this.element.querySelector('[class$="body"]') // the content of the accordion
    if(this.header) {
      this.header.addEventListener('click', () => {
        this.expanded = !this.expanded
      })
    }
    document.addEventListener('keydown', (event) => {
      if (keycode(event) === 'enter') {
        if (document.activeElement === this.element || this.element.contains(document.activeElement)) {
          this.expanded = !this.expanded
        }
      }
    })
  }

  get expanded () {
    return this._expanded
  }

  set expanded (state) {
    if (this.animating) {
      return
    }

    const expandedClass = 'is-expanded'
    this._expanded = state
    this.body.inert = !state // toggles focusability
    this.animating = true
    if (state) {
      // if accordions is opened
      if (this.group) this.collapseGroup() // collapses all other accordions with the same group name (if present)
      window.requestAnimationFrame(() => {
        this.body.style.height = this.expandedHeight + 'px'
        this.element.classList.add(expandedClass)
        this.header.setAttribute('aria-expanded', 'true')
        this.body.setAttribute('tabindex', '0')
        setTimeout(() => {
          this.body.style.height = 'auto'
          this.animating = false
        }, getTransitionDuration(this.body))
      })
    } else {
      let currentHeight = this.body.clientHeight
      this.body.style.height = currentHeight + 'px'
      window.requestAnimationFrame(() => {
        this.body.style.height = '0px'
        this.header.setAttribute('aria-expanded', 'false')
        this.body.setAttribute('tabindex', '-1')
        this.element.classList.remove(expandedClass)
        this.animating = false
      })
    }
  }

  /**
   * Creates a clone of the accordion element and hides it visually
   * in order to extract the calculated height of the content
   */
  get expandedHeight () {
    const clone = this.body.cloneNode(true)
    clone.style.height = 'auto'
    clone.style.visibility = 'hidden'
    clone.style.opacity = '0'
    clone.style.position = 'absolute'
    this.element.appendChild(clone)
    const fullHeight = clone.clientHeight
    this.element.removeChild(clone)
    return fullHeight
  }

  /**
   * Closes all accordions with the same group name
   */
  collapseGroup () {
    document.querySelectorAll(`[data-group="${this.group}"]`).forEach((groupCollapsible) => {
      if (groupCollapsible !== this.element) {
        groupCollapsible.Collapsible.expanded = false
      }
    })
  }
}
